import EmojiPicker from './EmojiPicker';

export default EmojiPicker;



// WEBPACK FOOTER //
// ./src/index.js